// extracted by mini-css-extract-plugin
export default {"sideBtn":"sidebar_sideBtn__P1Qje","popup":"sidebar_popup__dDpql","arrowTop":"sidebar_arrowTop__iifKL","popupWrapper":"sidebar_popupWrapper__Cv9qy"};